/**
 * getTimeZoneSign returns sign for the current time zone ("+" if the time zone is positive number, and "" if the time zone is zero or negative)
 * @param timeZoneOffset {Number} time zone as a number
 * @returns formatted time zone {String} string representation of the current time zone sign
 */
const cache = {};
export function getTimeZoneSign(timeZoneOffset) {
    if (!cache[timeZoneOffset]) {
        const timeZoneSign = (timeZoneOffset > 0) ? "+" : "";
        cache[timeZoneOffset] = timeZoneSign;
    }
    return cache[timeZoneOffset];
}
//# sourceMappingURL=TimeZoneSignHelper.js.map